import React, { useState, useEffect } from "react";
import PLinea from "../img/Boton_1.png";
import logoBBVA from "../img/BBVA-logo.png";
import logoBanorte from "../img/Banorte-logo.png";
import "./FormaPago.css";
import ventanilla from "../img/Boton_2.png";
import { PDFDownloadLink } from "@react-pdf/renderer";
import Pdf from "./Pdf";
import { Redirect } from "react-router-dom";
import GenerarReferencia from "../utilities/GenerarReferencia";

const FormaPago = ({ alumno, datospago, tablaConceptos }) => {
  const [pdf, cambiarPdf] = useState(false);
  const [onlinePayment, setOnlinePayment] = useState(false);
  const [banorteMessage, setBanorteMesagge] = useState("");
  const [loading, setLoading] = useState(false);

  const handleOnClick = () => {
    cambiarPdf(true);
  };

  const pagoBanorte = async (importe, referencia) => {
    let xObjEnc;
    // // xObjEnc =
    // //   "VK9yLIP+oYDPysNPwNV3cEkZ+JZnWtdGWCmoFDqoPHKs5TfK/t93VDVCwDkWnoddQvHbf1HYCEPh5Kt31I5hQTw3aapJC/m8yc35WEQqUGvXMP28DyET/eHFK3Nhpxlzz9tdPuqOUrllHt/e49EK1apw+LG8s0gyGEE3/L5YB8UYDUZHhLRpZvppK/XxbOBo4/G+QsHAimy+R7Q5KqY0GY2kTCtylwnFCia+gudhcudYCpoXxIh8JqXB1XjUtVrSv9uxMKkT5LP4Wz0i0/fAoU0O20o/0caoxELt8nVVE/e8yMIo0bRKi/pN1jkDTmihGSZQxdAXDiCIyjpNNhSMhQ==:::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";
    // console.log("Body");
    const body = {
      referencia,
      importe,
    };
    setLoading(true);
    await fetch(
      "https://api.multipagos.cecytejalisco.edu.mx/referenciaBanorte",
      // "http://localhost:15920/referenciaBanorte",
      {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        xObjEnc = data.data;
      })
      .catch((err) => console.log(err));

    // console.log("xObjEnc", xObjEnc);
    window.Payment.startPayment({
      Params: xObjEnc,
      onClosed: function (response) {
        setLoading(false);
        // TO DO Code Here when close the modal
        // console.log("modal cerrado");
      },
      onError: function (response) {
        console.log("error", response);
        // TO DO Code Here when an error occurred
        let mensaje = response.message
          ? response.message
          : "Ha ocurrido un error, intentalo nuevamente";
        setBanorteMesagge(mensaje);
        setLoading(false);
      },
      onSuccess: function (response) {
        console.log("response", response);
        // TO DO Code Here when operation is successful
        // setBanorteMesagge("Pago Exitoso");
        let mensaje = response.message ? response.message : "Pago Exitoso";
        setBanorteMesagge(mensaje);
        setLoading(false);
      },
      onCancel: function (response) {
        setLoading(false);
        // TO DO Code Here when user cancel operation
        // setBanorteMesagge("modal cerrado");
      },
    });
  };

  const completeTable = () => {
    for (let i = 0; i < tablaConceptos.length; i++) {
      tablaConceptos[i].id = i + 1;
      tablaConceptos[i].referencias = GenerarReferencia({
        matricula: alumno.codigo,
        servicio: tablaConceptos[i].clave,
        monto: tablaConceptos[i].precio,
      });
    }
    console.log("tablaConceptos", tablaConceptos);
  };

  useEffect(() => {
    completeTable();
  }, []);

  return alumno.codigo === "" ? (
    <Redirect to="/login" />
  ) : loading ? (
    <div className="loading_spinner">
      <div className="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  ) : onlinePayment ? (
    banorteMessage ? (
      <div className="FormaPago container">
        <h1 className="Banorte_message">{banorteMessage}</h1>
      </div>
    ) : (
      <div className="FormaPago container">
        <h2>Elige tu Forma de pago</h2>
        <div
          className="FormaPago__button"
          onClick={() => {
            setOnlinePayment(false);
          }}
        >
          {"volver"}
        </div>
        <div className="FormaPago-flex">
          <div
            className="FormaPago-linea"
            onClick={() => pagoBanorte(datospago.importe, datospago.referencia)}
          >
            <div className="contenedor-imagen">
              <input
                className="FormaPago-linea-img"
                type="image"
                src={logoBanorte}
              />
            </div>

            <p>
              Tarjetas de credito y debito <br /> (VISA y MasterCard) de
              cualquier banco.
            </p>
          </div>
          <form
            action="https://www.adquiramexico.com.mx:443/mExpress/pago/avanzado"
            method="post"
          >
            <input type="hidden" name="importe" value={datospago.importe} />
            <input
              type="hidden"
              name="referencia"
              value={datospago.referencia}
            />
            <input
              type="hidden"
              name="urlretorno"
              value="http://www.cecytejalisco.edu.mx/"
            />
            <input type="hidden" name="idexpress" value="2075" />
            <input type="hidden" name="financiamiento" value="0" />
            <input type="hidden" name="plazos" value="" />
            <input type="hidden" name="mediospago" value="000000" />
            <input type="hidden" name="signature" value={datospago.key} />
            {/* <div className="FormaPago-linea">
              <div className="contenedor-imagen">
                <input
                  className="FormaPago-linea-img"
                  type="image"
                  src={logoBBVA}
                />
              </div>

              <p>
                Tarjetas de credito y debito <br />
              </p>
            </div> */}
          </form>
        </div>
      </div>
    )
  ) : (
    <div className="FormaPago container">
      <h2>Elige tu Forma de pago</h2>
      <div className="FormaPago-flex">
        <div className="FormaPago-linea" onClick={() => setOnlinePayment(true)}>
          <div className="contenedor-imagen">
            <input className="FormaPago-linea-img" type="image" src={PLinea} />
          </div>

          <p>
            Tarjetas de credito y debito <br /> (VISA y MasterCard) de cualquier
            banco.
          </p>
        </div>
        <div className="FormaPago-referencia">
          <div className="contenedor-imagen">
            <input
              className="FormaPago-ventanilla-img"
              type="image"
              src={ventanilla}
              onClick={handleOnClick}
            />
          </div>

          <p>
            Pago en ventanilla, practicajas <br />
            BBVA y aplicación movil
          </p>
          {pdf ? (
            <PDFDownloadLink
              document={
                <Pdf
                  name={alumno.nombre}
                  code={alumno.codigo}
                  table={tablaConceptos}
                />
              }
              fileName="Orden de pago.pdf"
            >
              {({ blob, url, loading, error }) =>
                loading ? (
                  "Cagando documento..."
                ) : (
                  <h3 className="pdf">Descargar Orden de pago</h3>
                )
              }
            </PDFDownloadLink>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default FormaPago;
